import { Component, HostListener, OnInit } from "@angular/core";
import { TokenService } from "./core/services/token.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent implements OnInit {
  constructor(
    private tokenService: TokenService,
    private translate: TranslateService
  ) {
    translate.setDefaultLang("es");
    translate.use("es");
  }

  ngOnInit(): void {
    if (this.tokenService.isLogged()) {
      this.tokenService.setPersonalNumPages();
    }
  }
}
